<div class="margin-responsive">
  <!-- AÑADIR CLASE .hidden-chat-display AL CONTRAER EL CHAT -->
  <!-- AÑADIR CLASE .show-users-display PARA MOSTRAR CONTAINER LISTA DE PARTICIPANTES -->
  <div class="u-flex"
    [ngClass]="{'hidden-chat-display': !openChat, 'screen-share-publisher': screenShareFrame, 'show-users-display': openUsers, 'show-support-display' : openCloseTooltipSupport$ | async }">
    <!-- AÑADIR CLASE .full-screen-publisher PARA ACCIÓN DEL CLICK EN ICONO MINIATURA DEL MODO RESPONSIVE:  -->
    <div class="videocall-container"
      [ngClass]="{'full-screen-desktop': fullScreen, 'full-screen-publisher': fullScreenPublisher && participantsData?.length <= 2, 'full-screen-subscriber': !fullScreenPublisher && participantsData?.length === 2 }">
      @if(session){
        
        <ul class="videocall-windows"
          [ngClass]="{'full-desktop-publisher': !streamScreenShare && fullDesktopPublisher, 'three-more-participants': participantsData?.length >= 3, 'one-participants': participantsData?.length <= 1 }">
          <!-- COMPONENTE PUBLISHER -->
          <li class="app-publisher" [ngClass]="screenShareFrame? 'share-position' : '' ">
            @if(session){
              <sas-publisher [session]="session" [roomData]="roomData" [hasMsgs]="chatMessages" (hangUp)="hungUp($event)" [isConnect]="isConnect"
                (toggleSubscriberAudio)="toggleSubscriberAudio($event)" (toggleFullScreen)="toggleFullScreen($event)"
                (toggleFullScreenMiniature)="toggleFullScreenPublisher()" (toggleShareFrame)="toggleShareFrame()"
                (toggleChat)="toggleChat()" (publisherCreated)="publisherCreated($event)"></sas-publisher>
            }
          </li>
          <!-- COMPONENTE SUBSCRIBER -->
           @for(stream of streams; track stream.connection.id){
  
             <li class="app-subscriber">
               <sas-subscriber [stream]="stream" [session]="session" [subscriberAudio]="subscriberAudio"
                 [roomData]="roomData"></sas-subscriber>
               <i class="icon-miniature-off" (click)="toggleFullDeskTopPublisher()"></i>
             </li>
           }
  
          <!-- IMAGEN DE ESPERA - COMPONENTE SUBSCRIBER -->
           @if(streams.length === 0){
             
             <li class="app-subscriber">
               <div class="waiting-avatar-container">
                 <div class="waiting-avatar-photo"></div>
               </div>
             </li>
           }
  
        </ul>
      }

      @if(streamScreenShare){
        <!-- COMPONENTE SCREEN-SHARE -->
        <div class="screen-share-position" >
          <sas-screen-share [session]="session" [stream]="streamScreenShare" [streams]="streams">
          </sas-screen-share>
        </div>
      }
    </div>

    @if(session && features.chat){
      <!-- CHAT CONTAINER -->
      <div class="chat-container">
        <sas-chat [session]="session" [storedChatMessages]="storedChatMessages" [name]="roomData?.attendantName || ''"
          (toggleChat)="toggleChat()" [ngClass]="openChat ? 'display' : 'no-display'"
          (hasMessages)="messagesRecieved($event)" [participantsData]="participantsData"></sas-chat>
      </div>
    }

    @if(session && participantsData && features.participants_list){    
      <!-- CONTAINER LISTA DE USUARIOS // sas-invite-participants movido a sas-participants-tooltip -->
      <div class="users-container">
        <sas-participants-tooltip [participantsData]="participantsData"></sas-participants-tooltip>
      </div>
    }
    
    <!-- CONTAINER TELÉFONO SOPORTE TOOLTIP -->
    <div class="support-number-container">
      <sas-support-tooltip></sas-support-tooltip>
    </div>

  </div>
</div>

@let showModal = showModal$ | async;
@if(showModal && showModal.title!==''){
  <div class="popup-msg">
    <div class="overlay-info-container">
      <div class="close-modal-container pointer u-flex u-flex-align-items-center u-flex-justify-content-center"
        (click)="closeModal()">
        <span class="close-modal-text">{{ 'CHAT.CLOSE_MODAL' | translate }}</span>
        <i class="icon-close bold"></i>
      </div>
      <h4>{{ (showModal.bodyMessage || '') | translate }}</h4>
      <div class="file-name">{{showModal.data?.fileName}}</div>
      @if(showModal.data){
        <div class="u-flex u-flex-justify-content-between u-divider-bottom-sm">
          <button class="btn btn-primary btn-lg u-divider-top-xl" type="button" (click)="closeModal(showModal.data)">
            {{ 'CHAT.VIEW_BUTTON' | translate }}
          </button>
          <a class="clone-button u-divider-top-xl" [href]="showModal.data.urlBlob" [download]="showModal.data.fileName"
            (click)="closeModal()">
            {{ 'CHAT.DOWNLOAD_BUTTON' | translate }}
          </a>
        </div>
      }
    </div>
  </div>
}

@let showLostSignalModal = showLostSignalModal$ | async;
@if (showLostSignalModal) {
  <div class="popup-msg">
    <div class="overlay-info-container">
      <h3 class="u-divider-bottom-xl" [translate]="'MUTUA_NETWORK_TEST.LOST_SIGNAL_REDIRECT_ERROR'"></h3>
      <h4
        class="u-divider-top-xl"
      >{{'MUTUA_NETWORK_TEST.RELOAD_TEST_PAGE' | translate}}</h4>
      <button
        class="btn btn-primary btn-lg u-divider-top-xl"
        type="submit"
        (click)="closeModalLostSignal()"
      >
        {{ "MUTUA_NETWORK_TEST.ACCEPT_BUTTON" | translate }}
      </button>
    </div>
  </div>
}

@if(screenShareFrame){
  <!-- SCREEN-SHARE-FRAME -->
  <div  class="scren-share-frame">
  </div>
}